import axios from "axios";

// 创建axios实例
const requests = axios.create({
  // 设置baseURL地址
  // baseURL: "http://192.168.88.122",
  //   正式地址
  // baseURL: "https://npdhwh.fzbykj.com",
  baseURL: "https://fz.npdhwh.com",
  // baseURL: "http://hd.com/",
  // 测试地址
  // baseURL: "http://cswrite.fzbykj.com",
  // 定义统一的请求头
  headers: {
    "Content-Type": "Content-Type: application/json"
  },
  // 配置请求超时时间
  time: 10000
});
// 请求拦截器
requests.interceptors.request.use(
  config => {
    // console.log('请求拦截器正常');
    // if(config.headers){
    //     config.headers["Content-Type"] = 'multipart/form-data'
    // }
    return config;
  },
  error => {
    // 处理请求错误
    console.log(error); // 用于调试
    return Promise.reject(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  // 拦截器成功
  response => {
    const res = response.data;
    if (response.headers["Authorization"]) {
      res["Authorization"] = response.headers["Authorization"];
    }
    if (res.code && res.code !== 200) {
      // console.log('响应拦截器正常但code不为200');
      // 需要重新登录
      if (res.code === 401) {
        MessageBox.alert(
          "页面超过30分钟未操作，为保证账户安全，即将退出系统，请重新登录后操作",
          "",
          {
            confirmButtonText: "确定",
            callback: action => {
              // dispatch：含有异步操作，例如向后台提交数据，写法： this.$store.dispatch('action方法名',值)
              // commit：同步操作，写法：this.$store.commit('mutations方法名',值)
              // 调用退出登录接口
              // Vue.$store.dispatch('user/logout')
              // 跳转到登录页面
              router.replace({
                path: "/"
              });
            }
          }
        );
      } else {
        Message({
          message: res.msg,
          type: "error",
          center: true
        });
        return Promise.reject("error");
      }
    } else {
      // console.log('响应拦截器正常200');
      return response.data;
    }
  },
  // 拦截器失败
  error => {
    console.log("响应拦截器错误");
    if (
      error.message &&
      (error.message.indexOf("404") > 10 || error.message.indexOf("406") > 10)
    ) {
      error.message = "数据读取错误，请联系管理员";
    }
    Message({
      message: error.message,
      type: "error",
      center: true
    });
    return Promise.reject(error);
  }
);

// 封装get和post请求
export function get(url, params) {
  return instance.get(url, { params });
}

export function post(url, data) {
  return instance.post(url, data);
}
export default requests;



// WEBPACK FOOTER //
// ./src/utils/request.js